import type { ReusedOptions } from '../../../types/ReusedOptions.js';

export interface SyncOptions extends Pick<ReusedOptions, 'login'> {
  upload: boolean;
}
